import * as React from 'react'
import { ReactElement } from 'react'
import BaseCombobox, { BaseComboboxProps } from './BaseCombobox'
import { FixedPriceType, isActiveFixedPriceType } from '../../config/registrationConfig'
import useFixedPriceTypes from '../../hooks/useFixedPriceTypes'
import { parseDate } from '../../helpers/dateHelper'

export type FixedPriceTypeComboboxProps = Omit<BaseComboboxProps<FixedPriceType>, 'getEntityLabel' | 'getEntityValue' | 'entities'> &
    Partial<Pick<BaseComboboxProps<FixedPriceType>, 'getEntityLabel'>> & {
        date?: string
        currency?: string
    }

export default function FixedPriceTypeCombobox(props: FixedPriceTypeComboboxProps): ReactElement {
    const { fixedPriceTypes } = useFixedPriceTypes()

    return (
        <BaseCombobox<FixedPriceType>
            entities={fixedPriceTypes}
            filter={entity =>
                //type is active and the correct currency, or the type is selected.
                (isActiveFixedPriceType(entity, parseDate(props.date)) && (!props.currency || props.currency === entity.currency)) ||
                (props.selectedOptions || []).includes(entity.id)
            }
            alphabetical
            getEntityLabel={type => type.name}
            getEntityValue={type => type.id}
            placeholderKey={'base.fixedpricetypecombobox.placeholder'}
            {...props}
        />
    )
}
